<template>
  <div class="app-container">
    <div class="screen">
      <el-form
        label-width="200px"
        :inline="true"
        :model="screen"
        class="demo-form-inline"
        label-position="left"
      >
        <el-form-item label="选择园区">
          <el-select
            filterable
            v-model="screen.park_id"
            placeholder="请选择园区"
            :disabled="userInfo.park_id != 0"
            @change="screenParkchange"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检任务">
          <el-input
            v-model="screen.name"
            placeholder="请输入巡检任务名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="定期模式">
          <el-select
            filterable
            v-model="screen.pattern"
            placeholder="请选择定期模式"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="天" value="1"></el-option>
            <el-option label="周" value="2"></el-option>
            <el-option label="月" value="3"></el-option>
            <el-option label="季" value="4"></el-option>
            <el-option label="年" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否跨域（跨天）">
          <el-select
            filterable
            v-model="screen.is_cross_origin"
            placeholder="请选择是否跨天"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="否" value="1"></el-option>
            <el-option label="是" value="2"></el-option>
          </el-select>
        </el-form-item>
        <div v-show="fold">
          <el-form-item label="巡检人类型">
            <el-select
              filterable
              v-model="screen.patrol_type"
              placeholder="请选择巡检人类型"
              @change="changePatrolType"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="人" value="1"></el-option>
              <el-option label="角色" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="screen.patrol_type == 1" label="巡检人">
            <el-select
              filterable
              v-model="screen.patrol_user_id"
              placeholder="请选择巡检人"
              @change="this.$forceUpdate()"
            >
              <el-option v-for="(item,index) in patrolUserList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item> 
          <el-form-item v-if="screen.patrol_type == 2" label="巡检角色">
            <el-select
              filterable
              v-model="screen.patrol_role_id"
              placeholder="请选择巡检角色"
              @change="this.$forceUpdate()"
            >
            <el-option v-for="(item,index) in patrolRoleList" :key="index" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item> 
          <el-form-item label="状态">
            <el-select
              filterable
              v-model="screen.status"
              placeholder="请选择状态"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="启用" value="1"></el-option>
              <el-option label="停用" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务开始创建时间">
            <el-date-picker
              v-model="screen.start_create_time"
              type="date"
              placeholder="任务开始创建时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="任务结束创建时间">
            <el-date-picker
              v-model="screen.end_create_time"
              type="date"
              placeholder="任务结束创建时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否为共享任务">
            <el-select
              filterable
              v-model="screen.is_share"
              placeholder="请选择是否为共享任务"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="否" value="1"></el-option>
              <el-option label="是" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否跳过周末">
            <el-select
              filterable
              v-model="screen.is_skip_weekends"
              placeholder="请选择是否跳过周末"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="跳过" value="1"></el-option>
              <el-option label="不跳过" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="searchs">
            <el-button
              size="medium"
              type="primary"
              @click="(screen.page = 1), fetchData()"
              >查询</el-button
            >
            <el-button size="medium" type="primary" plain @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </div>
        <el-form-item class="searchs" v-show="!fold">
          <el-button
            size="medium"
            type="primary"
            @click="(screen.page = 1), fetchData()"
            >查询</el-button
          >
          <el-button size="medium" type="primary" plain @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <div class="fold" v-show="fold" @click="fold = !fold">
        折叠 <i class="el-icon-arrow-up"></i>
      </div>
      <div class="fold" v-show="!fold" @click="fold = !fold">
        展开 <i class="el-icon-arrow-down"></i>
      </div>
    </div>
    <div style="margin-top: 20px">
      <el-button
        type="info"
        @click="disable()"
        style="margin-bottom: 5px"
        :disabled="multipleSelection.length == 0"
        v-if="roles.includes('/patrol/task_disable')"
        >批量停用</el-button
      >
      <el-button
        type="success"
        @click="enable()"
        style="margin-bottom: 5px"
        :disabled="multipleSelection.length == 0"
        v-if="roles.includes('/patrol/task_enable')"
        >批量启用</el-button
      >
      <el-button
        size="medium"
        type="primary"
        @click="addMenu(0)"
        style="margin-bottom: 5px"
        v-if="roles.includes('/patrol/task_add')"
        >添加</el-button
      >
    </div>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="所属园区" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="任务名称" align="center">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="创建人" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.system_admin">{{
            scope.row.system_admin.username
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="巡检人/角色" align="center" width="150">
        <template slot-scope="scope">
          <template v-if="scope.row.patrol_user.length > 0">
            <div :key="index" v-for="(item, index) in scope.row.patrol_user">
              <span v-if="index != 0">，</span> {{ item.user.name }}
            </div>
          </template>
          <template v-if="scope.row.patrol_role.length > 0">
            <div :key="index" v-for="(item, index) in scope.row.patrol_role">
              <span v-if="index != 0">，</span> {{ item.system_role.title }}
            </div>
          </template>
        </template>

        <!-- <template slot-scope="scope">
          <div :key="index" v-for="(item, index) in scope.row.patrol_user">
            <span v-if="index != 0">，</span> {{ item.user.name }}
          </div>
          <span v-if="scope.row.patrol_user">{{
            scope.row.patrol_user.name
          }}</span>
          <span v-if="scope.row.patrol_role">{{
            scope.row.patrol_role.title
          }}</span>
        </template> -->
      </el-table-column>
      <el-table-column label="持续天数" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.duration_day }}</span>
        </template>
      </el-table-column>
      <el-table-column label="定期模式" align="center">
        <template slot-scope="scope">
          {{
            scope.row.pattern == 1
              ? "天"
              : scope.row.pattern == 2
              ? "周"
              : scope.row.pattern == 3
              ? "月"
              : scope.row.pattern == 4
              ? "季"
              : "年"
          }}
        </template>
      </el-table-column>
      <el-table-column label="任务有效期" align="center" width="200">
        <template slot-scope="scope">
          {{ scope.row.start_date }} 至 {{ scope.row.end_date }}
        </template>
      </el-table-column>
      <el-table-column label="任务开始时间" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.start_date }}
        </template>
      </el-table-column>
      <el-table-column label="任务结束时间" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.end_date }}
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="250"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="info"
            @click="disable(scope.row.id, 'single')"
            v-if="
              roles.includes('/patrol/task_disable') && scope.row.status == 1
            "
            >停用</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="enable(scope.row.id, 'single')"
            v-if="
              roles.includes('/patrol/task_enable') && scope.row.status == 2
            "
            >启用</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/patrol/task_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/patrol/task_edit')"
            >编辑</el-button
          >
          <el-button
            class="btnTop"
            size="mini"
            type="primary"
            @click="handleCopy(scope.row)"
            v-if="roles.includes('/patrol/task_copy')"
            >复制</el-button
          >
          <el-button
            class="btnTop"
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/patrol/task_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      @opened="openDrawer"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype != 'add' || userInfo.park_id != 0"
            @change="parkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检路线" prop="patrol_path_id">
          <el-select
            filterable
            v-model="ruleForm.patrol_path_id"
            placeholder="请选择巡检路线"
            :disabled="cztype == 'see' || !ruleForm.park_id"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in patrolPathList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检任务的名称" prop="name">
          <el-input
            class="w4"
            v-model="ruleForm.name"
            placeholder="请输入巡检任务的名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务有效时间">
          <el-date-picker
            v-model="timeData"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否需要扫码巡检" prop="is_scan">
          <el-radio-group
            v-model="ruleForm.is_scan"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="定期模式" prop="pattern">
          <el-radio-group
            v-model="ruleForm.pattern"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">天</el-radio>
            <el-radio :label="2">周</el-radio>
            <el-radio :label="3">月</el-radio>
            <el-radio :label="4">季</el-radio>
            <el-radio :label="5">年</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" v-if="ruleForm.pattern == 1">
          <div class="headbox">
            <span>每天：</span>
            <el-button type="info" @click="addDomain()">添加</el-button>
          </div>
          <el-table
            :data="timeList"
            :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
            style="width: 100%"
          >
            <el-table-column label="开始时间">
              <template slot-scope="scope">
                <el-time-picker
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                  v-model="scope.row.start_time"
                  placeholder="开始时间"
                >
                </el-time-picker>
              </template>
            </el-table-column>
            <el-table-column label="结束时间">
              <template slot-scope="scope">
                <el-time-picker
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                  v-model="scope.row.end_time"
                  placeholder="结束时间"
                >
                </el-time-picker>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="removeDomain(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="" v-if="ruleForm.pattern == 2">
          <el-checkbox-group v-model="checkList">
            <el-checkbox :label="1">周一</el-checkbox>
            <el-checkbox :label="2">周二</el-checkbox>
            <el-checkbox :label="3">周三</el-checkbox>
            <el-checkbox :label="4">周四</el-checkbox>
            <el-checkbox :label="5">周五</el-checkbox>
            <el-checkbox :label="6">周六</el-checkbox>
            <el-checkbox :label="7">周七</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          :label="ruleForm.pattern == 3 ? '每月的第几天' : '每季的第几天'"
          v-if="ruleForm.pattern == 3 || ruleForm.pattern == 4"
        >
          <el-input-number v-model="dayNum" :step="1"></el-input-number>
          <!-- <el-input
            class="w4"
            v-model="dayNum"
            placeholder="请输入账号名称"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="开始日期" v-if="ruleForm.pattern == 5">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="year_start_time"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>

        <div v-if="ruleForm.pattern != 1">
          <el-form-item label="开始时间" prop="status">
            <el-time-picker
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              v-model="timeStr.start_time"
              placeholder="任意时间点"
            >
            </el-time-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="status">
            <el-time-picker
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              v-model="timeStr.end_time"
              placeholder="任意时间点"
            >
            </el-time-picker>
          </el-form-item>
        </div>
        <el-form-item
          label="是否跳过周末"
          prop="is_skip_weekends"
          v-show="ruleForm.pattern != 2"
        >
          <el-radio-group
            v-model="ruleForm.is_skip_weekends"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">跳过</el-radio>
            <el-radio :label="2">不跳过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否跳过国定假期" prop="is_jump_holiday">
          <el-radio-group
            v-model="ruleForm.is_jump_holiday"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="2">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="持续时间" prop="duration_day">
          <el-input
            :disabled="cztype == 'see'"
            type="Number"
            class="w4 numInput"
            v-model="ruleForm.duration_day"
            placeholder="请输入持续时间"
            ><template slot="append">天</template></el-input
          >
        </el-form-item>
        <el-form-item prop="is_share">
          <span slot="label">
            是否共享
            <el-tooltip
              content="开启后参与的巡检人可以共同完成该任务"
              effect="light"
              placement="top-start"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-radio-group
            v-model="ruleForm.is_share"
            :disabled="cztype == 'see'"
            @input="ChangeShare"
          >
            <el-radio :label="1">否</el-radio>
            <el-radio :label="2">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="巡检人类型" prop="patrol_type">
          <el-radio-group
            v-model="ruleForm.patrol_type"
            :disabled="cztype == 'see'"
            @change="patrolTypeChange"
          >
            <el-radio :label="1">人</el-radio>
            <el-radio :label="2">角色</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="指定巡检人"
          prop="patrol_user_id"
          v-if="ruleForm.patrol_type == 1"
        >
          <span slot="label"
            ><span style="color: #f00">* </span>指定巡检人</span
          >
          <el-select
            filterable
            v-model="ruleForm.patrol_user_id"
            placeholder="指定巡检人"
            :disabled="cztype == 'see'"
            :multiple="ruleForm.is_share == 2"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in userList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="指定巡检角色"
          prop="patrol_role_id"
          v-if="ruleForm.patrol_type == 2"
        >
          <span slot="label"
            ><span style="color: #f00">* </span>指定巡检角色</span
          >
          <el-select
            filterable
            v-model="ruleForm.patrol_role_id"
            placeholder="指定巡检角色"
            :disabled="cztype == 'see'"
            :multiple="ruleForm.is_share == 2"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="item in roleList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add' || cztype == 'copy'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <!-- <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button> -->
          <el-button
            v-if="cztype !== 'see'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  taskLists,
  addTask,
  infoTask,
  editTask,
  delTask,
  openPark,
  openRole,
  openPatrolPath,
  openAgoUser,
  disableTask,
  enableTask,
  copyTask,
} from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      fold: false,
      // 任务有效时间
      timeData: [],
      // 周期列表
      checkList: [],
      // 时间列表
      timeList: [
        {
          start_time: "",
          end_time: "",
        },
      ],
      // 第几天
      dayNum: 1,
      // 年的时候开始日期
      year_start_time: "",
      timeStr: {
        start_time: "",
        end_time: "",
      },
      screen: {
        page_size: 15,
        page: 1,
        park_id: "",
        status: "",
        name: "",
        pattern: "",
        is_cross_origin: "",
        start_create_time: "",
        end_create_time: "",
        patrol_type: "",
        is_share: "",
        is_skip_weekends: "",
        patrol_user_id:'',
        patrol_role_id:''
      },
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加用户",
      token: getToken(),
      total: 0,
      ruleForm: {
        park_id: "",
        name: "",
        patrol_path_id: "",
        start_date: "",
        end_date: "",
        patrol_type: 1,
        patrol_user_id: "",
        patrol_role_id: "",
        status: 1,
        pattern: 1,
        patrol_pattern_json: "",
        system_admin_id: "",
      },
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        name: [
          { required: true, message: "请输入巡检任务的名称", trigger: "blur" },
        ],
        patrol_path_id: [
          { required: true, message: "请选择巡检路线", trigger: "blur" },
        ],
        pattern: [
          { required: true, message: "请选择活动资源", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        patrol_type: [
          { required: true, message: "请选择巡检类型", trigger: "change" },
        ],
        patrol_user_id: [
          { required: false, message: "请选择巡检人", trigger: "change" },
        ],
        patrol_role_id: [
          { required: false, message: "请选择巡检角色", trigger: "change" },
        ],
      },
      multipleSelection: [],
      cztype: "",
      oldImg: "",
      parkList: [],
      roleList: [],
      userList: [],
      patrolPathList: [],
      patrolUserList:[],
      patrolRoleList:[]
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      this.screen.type = this.userInfo.type;
      this.getPath(this.userInfo.park_id);
      this.getAgoUser(this.userInfo.park_id);
      this.getRole(this.userInfo.park_id);
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    screenParkchange(e) {
      this.screen.patrol_user_id = ''

      this.screen.patrol_type = ''
      this.screen.patrol_role_id = ''
    },
    changePatrolType(e){
      this.screen.patrol_user_id = null
      this.screen.patrol_role_id = null
      console.log(e)
      if(e == 1){
        let data  ={ park_id: this.screen.park_id, type: 1, is_page: 2,is_youke:2 }
        // 获取巡检人
        openAgoUser(data).then((res) => {
        this.patrolUserList = res.data.lists;
      });
      }else if(e == 2){
        // 获取巡检角色
        const data = {
        is_page: 2,
        is_tree: 1,
        park_id: this.screen.park_id,
        type: 1,
        role_type: 2,
      };
      openRole(data).then((res) => {
        this.patrolRoleList = res.data.lists;
      });
      }
    },
    
    openDrawer() {
      this.$refs.ruleForm.clearValidate();
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 停用任务
    disable(id, type) {
      var that = this;
      let ids = [];
      if (type == "single") {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
      }
      this.$confirm("确认停用任务？")
        .then(() => {
          disableTask({ id: ids.join(",") }).then((res) => {
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 启用任务
    enable(id, type) {
      var that = this;
      let ids = [];
      if (type == "single") {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
      }
      this.$confirm("确认启用任务？")
        .then(() => {
          enableTask({ id: ids.join(",") }).then((res) => {
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 触发共享
    ChangeShare(e) {
      if (e == 2) {
        this.ruleForm.patrol_user_id = [];
        this.ruleForm.patrol_role_id = [];
      } else {
        this.ruleForm.patrol_user_id = "";
        this.ruleForm.patrol_role_id = "";
      }
    },
    reset() {
      this.screen = {
        page_size: 15,
        page: 1,
        park_id: "",
        status: "",
        name: "",
        pattern: "",
        is_cross_origin: "",
        start_create_time: "",
        end_create_time: "",
        patrol_type: "",
        is_share: "",
        is_skip_weekends: "",
        patrol_user_id:'',
        patrol_role_id:''
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
        this.screen.type = this.userInfo.type;
        this.getPath(this.userInfo.park_id);
        this.getAgoUser(this.userInfo.park_id);
        this.getRole(this.userInfo.park_id);
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    // 设置巡检类型回调
    patrolTypeChange(e) {
      // this.ruleForm.patrol_role_id = "";
      // this.ruleForm.patrol_user_id = "";
      if (this.ruleForm.is_share == 1) {
        this.ruleForm.patrol_role_id = "";
        this.ruleForm.patrol_user_id = "";
      } else {
        this.ruleForm.patrol_role_id = [];
        this.ruleForm.patrol_user_id = [];
      }
      // if (e == 1) {
      //   this.ruleForm.patrol_role_id = "";
      // } else if (e == 2) {
      //   this.ruleForm.patrol_user_id = "";
      // }
    },
    removeDomain(index) {
      this.timeList.splice(index, 1);
    },
    addDomain() {
      this.timeList.push({
        start_time: "",
        end_time: "",
      });
    },
    getAgoUser(id) {
      openAgoUser({ park_id: id, type: 1, is_page: 2,is_youke:2 }).then((res) => {
        this.userList = res.data.lists;
      });
    },
    // 选择园区
    parkChange(e) {
      this.ruleForm.patrol_role_id = "";
      this.ruleForm.patrol_user_id = "";
      this.ruleForm.patrol_path_id = "";
      this.getPath(e);
      this.getAgoUser(e);
      this.getRole(e);
    },
    getPath(id) {
      openPatrolPath({ park_id: id, is_page: 2 }).then((res) => {
        this.patrolPathList = res.data.lists;
      });
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.start_date = this.timeData[0];
          this.ruleForm.end_date = this.timeData[1];
          if (this.ruleForm.pattern == 1) {
            this.ruleForm.patrol_pattern_json = JSON.stringify(this.timeList);
          } else if (this.ruleForm.pattern == 2) {
            const list = {};
            this.checkList.forEach((item, index) => {
              this.$set(list, item, this.timeStr);
            });
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          } else if (this.ruleForm.pattern == 5) {
            const list = {};
            this.$set(list, this.year_start_time, this.timeStr);
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          } else {
            const list = {};
            this.$set(list, this.dayNum, this.timeStr);
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          }

          if (this.ruleForm.is_share == 2) {
            this.ruleForm.patrol_role_id =
              this.ruleForm.patrol_role_id.toString(",");
            this.ruleForm.patrol_user_id =
              this.ruleForm.patrol_user_id.toString(",");
          }
          this.$confirm("修改后，原任务数据将会删除，是否确认修改？", {
            type: "warning",
          })
            .then(() => {
              editTask(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  if (this.oldImg) {
                    that.delImg(this.oldImg);
                  }
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      // this.oldImg = val.avatar_url
      // this.getPath(val.park_id);
      this.getInfo(val.id, val.park_id);
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.getPath(val.park_id);
      // this.ruleForm = val
      this.getInfo(val.id, val.park_id);
      this.drawer = true;
    },
    // 复制
    handleCopy(val) {
      this.cztype = "copy";
      this.drawerTitle = "复制";
      // this.ruleForm = val
      this.getInfo(val.id, val.park_id, "copy");
      this.drawer = true;
    },
    getInfo(id, parkId, type) {
      this.parkChange(parkId);
      infoTask({ id: id }).then((res) => {
        this.timeData = [];
        this.ruleForm = {
          id: res.data.info.id,
          park_id: res.data.info.park_id,
          name: res.data.info.name,
          patrol_path_id: res.data.info.patrol_path_id,
          start_date: res.data.info.start_date,
          end_date: res.data.info.end_date,
          patrol_type: res.data.info.patrol_type,
          status: res.data.info.status,
          pattern: res.data.info.pattern,
          system_admin_id: res.data.info.system_admin_id,
          is_scan: res.data.info.is_scan,
          duration_day: res.data.info.duration_day,
          is_share: res.data.info.is_share,
          is_skip_weekends: res.data.info.is_skip_weekends,
          is_jump_holiday: res.data.info.is_jump_holiday,
        };
        if (res.data.info.is_share == 1) {
          this.ruleForm.patrol_role_id =
            res.data.info.patrol_role_id != 0
              ? res.data.info.patrol_role_id
              : "";
          this.ruleForm.patrol_user_id =
            res.data.info.patrol_user_id != 0
              ? res.data.info.patrol_user_id
              : "";
        } else {
          this.ruleForm.patrol_role_id = [];
          this.ruleForm.patrol_user_id = [];
          if (res.data.info.patrol_type == 1) {
            res.data.info.patrol_user.forEach((item, index) => {
              this.ruleForm.patrol_user_id.push(item.user_id);
            });
          } else {
            res.data.info.patrol_role.forEach((item, index) => {
              this.ruleForm.patrol_role_id.push(item.system_role_id);
            });
          }
          // if(res.data.info.patrol_role.length>0){

          // }
          // if(res.data.info.patrol_user.length>0){

          // }
        }
        if (res.data.info.pattern == 1) {
          this.timeList = res.data.info.patrol_pattern_json;
        } else if (res.data.info.pattern == 2) {
          this.checkList = Object.keys(res.data.info.patrol_pattern_json);
          this.timeList = res.data.info.patrol_pattern_json;
          this.checkList = this.checkList.map(function (item, index) {
            return Number(item);
          });
          this.timeStr = res.data.info.patrol_pattern_json[this.checkList[0]];
        } else if (res.data.info.pattern == 5) {
          this.year_start_time = Object.keys(
            res.data.info.patrol_pattern_json
          )[0];
          this.timeStr =
            res.data.info.patrol_pattern_json[this.year_start_time];
        } else {
          this.dayNum = Object.keys(res.data.info.patrol_pattern_json)[0];
          this.timeStr = res.data.info.patrol_pattern_json[this.dayNum];
        }
        this.timeData.push(res.data.info.start_date);
        this.timeData.push(res.data.info.end_date);
        // this.getAgoUser(res.data.info.park_id);
        // this.getRole(res.data.info.park_id);
        if (type == "copy") {
          delete this.ruleForm.id;
        }
      });
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          delTask({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.start_date = this.timeData[0];
          this.ruleForm.end_date = this.timeData[1];
          if (this.ruleForm.pattern == 1) {
            this.ruleForm.patrol_pattern_json = JSON.stringify(this.timeList);
          } else if (this.ruleForm.pattern == 2) {
            const list = {};
            this.checkList.forEach((item, index) => {
              this.$set(list, item, this.timeStr);
            });
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          } else if (this.ruleForm.pattern == 5) {
            const list = {};
            this.$set(list, this.year_start_time, this.timeStr);
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          } else {
            const list = {};
            this.$set(list, this.dayNum, this.timeStr);
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          }
          if (this.ruleForm.is_share == 2) {
            this.ruleForm.patrol_role_id =
              this.ruleForm.patrol_role_id.toString(",");
            this.ruleForm.patrol_user_id =
              this.ruleForm.patrol_user_id.toString(",");
          }
          this.$confirm("确认提交？")
            .then(() => {
              addTask(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        name: "",
        patrol_path_id: "",
        start_date: "",
        end_date: 1,
        patrol_type: 1,
        patrol_user_id: "",
        patrol_role_id: "",
        status: 1,
        pattern: 1,
        patrol_pattern_json: "",
        system_admin_id: this.userInfo.id,
        is_scan: 1,
        duration_day: "",
        is_share: 1,
        is_skip_weekends: 2,
        is_jump_holiday: 1,
      };
      this.timeData = [];
      this.checkList = [];
      this.timeList = [
        {
          start_time: "",
          end_time: "",
        },
      ];
      this.dayNum = 1;
      this.year_start_time = "";
      this.timeStr = {
        start_time: "",
        end_time: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
        this.getPath(this.userInfo.park_id);
        this.getAgoUser(this.userInfo.park_id);
        this.getRole(this.userInfo.park_id);
      }
      this.roleList = [];
      this.userList = [];
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取角色
    getRole(id) {
      const data = {
        is_page: 2,
        is_tree: 1,
        park_id: id,
        type: 1,
        role_type: 2,
      };
      openRole(data).then((res) => {
        this.roleList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      // this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      taskLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding: 0 20px;
  overflow: auto;
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
::v-deep .screen {
  padding: 0 50px 10px;
  border-bottom: 1px solid #e4e7ed;
  .el-input {
    width: 200px;
  }
  .el-form--inline .el-form-item {
    width: 23%;
  }
}
.headbox {
  display: flex;
  justify-content: space-between;
}
.btnTop {
  margin-top: 10px;
}

.searchs {
  ::v-deep .el-form-item__label {
    opacity: 0 !important;
    display: block;
  }
}
.fold {
  text-align: center;
  font-size: 14px;
  color: #606266;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
